import { render } from "./QuickShip.vue?vue&type=template&id=64fbc2ef&ts=true"
import script from "./QuickShip.vue?vue&type=script&lang=ts"
export * from "./QuickShip.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__